import {
    Button, Grid,
    InputBase,
    Paper
} from '@material-ui/core';
import React, { useState } from 'react';
import { loadCode, saveCode } from '../../storage';
function Login() {
    const [code, setCode] = useState(loadCode);

    const handleEnter = (e) => {
        saveCode(code)
				window.location.reload()
    }
    return (
        <div className="Login">
            <Grid container justify="center">
                <Paper style={{ width: '50%', marginTop: '150px' }}>
                    <div style={{padding:'3em'}}>
                    <h2>Entry code</h2>
                    <div>
                        <InputBase
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="magic word..."
                            style={{ width: "80%" }}                        // classes={{
                            //     root: classes.inputRoot,
                            //     input: classes.inputInput,
                            // }}
                            inputProps={{ 'aria-label': 'search' }}
                        />
                        <Button type="primary" onClick={handleEnter}>Do it!</Button>
                    </div>
                    </div>
                </Paper>
            </Grid>

        </div>
    )
}

export default Login
